'use strict';

/**
 *
 * @name: nownessApp.user
 *
 */

import ModalsRun from './nn-modals.run';

import LoginModalDirective from './nn-login-modal/nn-login-modal.directive';
import NnSearchModule from './nn-search-modal/nn-search.module';
import WechatModalDirective from './nn-wechat-modal/nn-wechat-modal.directive';
import NnSlideshowModalDirective from './nn-slideshow-modal/nn-slideshow-modal.directive';
import NnBlackAndWhiteModalDirective from './nn-black-and-white-modal/nn-black-and-white-modal.directive';
import NnSplashimageModalDirective from './nn-splashimage-modal/nn-splashimage-modal.directive';
import NnSplashscreenAdModalDirective from './nn-splashscreen-ad-modal/nn-splashscreen-ad-modal.directive';
import NnExperimentsModalDirective from './nn-experiments-modal/nn-experiments-modal.directive';
import NnVideoPlayerModalDirective from './nn-video-player-modal/nn-video-player-modal.directive';

import NnCloseModalButtonDirective from './nn-close-modal-button.directive';
import NnModalsService from './nn-modals.service';

const ModalsModule = angular
  .module('nownessApp.modals', [
    NnSearchModule
  ])
  .run(ModalsRun)
  .directive('nnLoginModal', LoginModalDirective)
  .directive('nnSlideshowModal', NnSlideshowModalDirective)
  .directive('nnWechatModal', WechatModalDirective)
  .directive('nnBlackAndWhiteModal', NnBlackAndWhiteModalDirective)
  .directive('nnSplashimageModal', NnSplashimageModalDirective)
  .directive('nnSplashscreenAdModal', NnSplashscreenAdModalDirective)
  .directive('nnExperimentsModal', NnExperimentsModalDirective)
  .directive('nnVideoPlayerModal', NnVideoPlayerModalDirective)

  .directive('nnCloseModalButton', NnCloseModalButtonDirective)
  .service('nnModalsService', NnModalsService);

export default ModalsModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-modals.module.js